import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import * as actions from './couponsActions';
import CouponsModal from './components/CouponsModal';
import RedeemProduct from './components/RedeemProduct';

const CouponsContainer = ({
  couponsReducer,
  setCouponsModalIsVisible,
  applyCouponCode,
  cartScreen,
  validatePromoCode,
}) => {
  const handleCouponSubmit = (couponCode) => {
    applyCouponCode(couponCode);
  };

  const handlePromoCodeSubmit = (promoCode) => validatePromoCode(promoCode);

  const {
    couponsModalIsVisible,
    couponType,
    couponValue,
    isRequesting,
    isValidPromocode,
    promoType,
  } = couponsReducer;
  return (
    <Fragment>
      {promoType === 'coupon' ? (
        <CouponsModal
          id='Coupons-CouponsModal'
          couponsModalIsVisible={couponsModalIsVisible}
          setCouponsModalIsVisible={setCouponsModalIsVisible}
          handleCouponSubmit={handleCouponSubmit}
          couponType={couponType}
          couponValue={couponValue}
          isRequesting={isRequesting}
        />
      ) : promoType === 'promo' ? (
        <RedeemProduct
          id='Redeem-ProductModal'
          couponsModalIsVisible={couponsModalIsVisible}
          setCouponsModalIsVisible={setCouponsModalIsVisible}
          handleCouponSubmit={handlePromoCodeSubmit}
          couponType={couponType}
          couponValue={couponValue}
          isRequesting={isRequesting}
          isValidPromocode={isValidPromocode}
        />
      ) : null}
    </Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    couponsReducer: state.couponsReducer,
    cartScreen: state.cartReducer.cartScreen,
  };
};

export default connect(mapStateToProps, actions)(CouponsContainer);
